module.exports = Object.freeze({
  API_URL: process.env.REACT_APP_API_URL || "http://localhost:56866",
  ADMINUI_URL: process.env.REACT_APP_ADMINUI_URL || "http://localhost:3001"
});
